import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal  } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { noWhitespaceValidator } from '../../../utils/no-whitespace.validator';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { response } from 'express';
import { PropertyService } from '../../../services/property.service';
import { ToastService } from '../../../services/toast.service';
import { ResetPasswordIsCreateFlag, ToastType } from '../../../enums/config.enum';


@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatProgressSpinnerModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  responseMessage: string | null = null;
  showInvalidEmailMessage = false;
  errorMessage: string | null = null;
  isLoading: boolean = false;
  isLoggedIn = false;
  keyVal: string | null = null;
  loading: boolean = false;
  responseErrorMessage = signal('');
  isCreatePassword = signal<boolean>(false);
  toastService = inject(ToastService);
  private route = inject(ActivatedRoute);
  heading = signal<string>('Reset Password');
  buttonText = signal<string>('Reset');
  invalidErrorResponse = signal('');

  constructor(private fb: FormBuilder,private authService: AuthService,private router : Router, private propertyService: PropertyService) {
    this.forgotPasswordForm = this.fb.group({
      newPassword: [
        '', 
        [
          Validators.required,
          noWhitespaceValidator,
          Validators.minLength(8),
          Validators.maxLength(64),
          Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*])/)
        ]
      ],
      // newPassword:['',[Validators.required, noWhitespaceValidator]],
      confirmPassword: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(64)]]
    }, {
      validators: this.passwordMatchValidator
    });
  } 


  ngOnInit() {
    //handle dynamic headings and button based on create and reset password
    this.route.url.subscribe(url => {
      const currentPath = url[0]?.path;
      if (currentPath === 'create-password') {
        this.heading.set('Create Password');
        this.buttonText.set('Submit');
        this.isCreatePassword.set(true);
      } else {
        this.heading.set('Reset Password');
        this.buttonText.set('Reset');
        this.isCreatePassword.set(false);
      }
    });

    this.route.queryParams.subscribe(params => {
      let requestId = params['request'];
      if(requestId){
        this.keyVal = requestId;
        this.checkValidationKey();
      }
    })
  }

  checkValidationKey(){
    if(this.keyVal){
      this.authService.validatePasswordLink(String(this.keyVal)).subscribe({
        next: (response) => {

          let message = response.message;
          try {
            // Parse the message if it's a stringified JSON
            const parsedMessage = JSON.parse(response.message);
            message = parsedMessage.message;
          } catch (e) {
          }
          
          if(!response.success){
            this.responseErrorMessage.set(message);
            this.authService.setLoading(false);
            this.forgotPasswordForm.disable(); // disable the form fields when reset link is expired
          }else{
            // ValidKey Success Response
            if(response.message){
              let emailRes = response.message.replace(/["']/g, "");              
              sessionStorage.setItem('email', emailRes);
            }
            this.authService.setLoading(false);
          }
        }, error: (error) => {
          console.log(error,"bad request");
          
          let errorMessage = 'The reset link is expired. Request a new link to reset the password.';
        try {
          const parsedError = JSON.parse(error.error?.message || '{}');
          errorMessage = parsedError.message || errorMessage;
        } catch (e) {
          console.log("Error message is not JSON formatted.");
        }

        this.responseErrorMessage.set(errorMessage);
        this.authService.setLoading(false);
        this.forgotPasswordForm.disable();// disable the form fields when reset link is expired
        }
      });
    }
  }


  passwordMatchValidator(form: FormGroup) {
    return form.get('newPassword')?.value === form.get('confirmPassword')?.value 
        ? null : { passwordMismatch: true };
    } 


  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
        this.forgotPasswordForm.markAllAsTouched();
        return;
    }

    const { newPassword } = this.forgotPasswordForm.value;
    const email = sessionStorage.getItem('email'); 
    if (email) {
      const isCreateFlag = this.isCreatePassword() ? ResetPasswordIsCreateFlag.CREATE_PASSWORD : ResetPasswordIsCreateFlag.RESET_PASSWORD; // settting isCreate Flag
      this.authService.resetPassword(email,newPassword, isCreateFlag).subscribe({
          next: (response) => {
            this.authService.setLoading(false)
              this.responseMessage = "Password has been reset successfully. Please login again to continue. "; 
              this.toastService.addNotification({message: "Password has been reset successfully. Please login again to continue.", type: ToastType.Success});
              this.showInvalidEmailMessage = false;
              this.router.navigate(['/login'])
          },
          error: (error: HttpErrorResponse) => {
            this.authService.setLoading(false)
              console.error('Error resetting password:', error);
              if(error?.status === 400){
                this.invalidErrorResponse.set("The new password must be different from the previous password ")
              }else{
                this.invalidErrorResponse.set('An error occurred. Please try again later.'); 
              }
            }
      });
  } else {
      alert('Error: Email not found.');
  }
}

navigate(){
    
  this.router.navigate(['/login'])

}
}



